import {
  FormControl,
  FormLabel,
  MenuItem,
  Select,
  Typography,
  type SelectVariants,
} from '@mui/material';
import type { Provider } from '@repo/api-gw-sdk';

import { useSupportedRegions } from './supportedRegions';

import { SelectPlaceholder } from '../selectPlaceholder';

export const AllRegionsSelector = ({
  regionName,
  setRegionName,
  title,
  provider,
  size = 'small',
  variant = 'outlined',
  disabled = false,
}: {
  regionName?: string;
  setRegionName: (regionName: string) => void;
  title?: string;
  provider: Provider;
  size?: 'small' | 'medium' | 'large';
  variant?: SelectVariants;
  disabled?: boolean;
}) => {
  const supportedRegions = useSupportedRegions();
  return (
    <FormControl size='small' className='w-full' disabled={disabled}>
      {title && (
        <FormLabel>
          <Typography variant='subtitle1'>{title}</Typography>
        </FormLabel>
      )}
      <Select
        size={size}
        sx={{ paddingLeft: '8px' }}
        variant={variant}
        displayEmpty
        disabled={disabled}
        renderValue={(value) => {
          if (!value) {
            return <SelectPlaceholder />;
          }
          return value;
        }}
        data-testid='region'
        value={regionName || ''}
        onChange={(event) => setRegionName(event.target.value)}
      >
        {supportedRegions[provider]?.map((region, i) => {
          return (
            <MenuItem value={region} key={i} data-testid={`region-${region}`}>
              {region}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
